export function initWorkArchive() {
    const archive    = document.querySelector( '.work-archive' );
    const headingWrap = archive?.querySelector( '.work-archive__heading-wrap' );
    if ( ! archive || ! headingWrap ) return;

    function updatePadding() {
        const wrapHeight  = headingWrap.offsetHeight; // heading + padding-bottom
        const topOffset   = window.innerHeight / 2;   // 50vh
        archive.style.paddingTop = ( topOffset + wrapHeight / 2 ) + 'px';
    }

    updatePadding();

    const ro = new ResizeObserver( updatePadding );
    ro.observe( headingWrap );
}
